webpackJsonp([4],{

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(71);
module.exports = __webpack_require__(72);


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

// $('.toproom-share').hover(function () {
//         $('.sharepanel').show();
//     },
//     function () {
//         $('.sharepanel').hide();
//     }
// );

$('body').on('mouseenter', '.toproom-share', function () {
    var x = $(this).offset();
    x.left -= 20;
    $('.sharepanel').css('left', x.left + 'px');
    // $('.sharepanel').css('top', x.top + 'px');

    $('.sharepanel').show();
});
$('body').on('mouseleave', '.toproom-share', function () {
    setTimeout('hidedropdown()', 200);
});

function hidedropdown() {
    if ($('.sharepanel').data('show') != 'true') {
        $('.sharepanel').hide();
    }
}

$('.sharepanel').hover(function () {
    $('.sharepanel').data('show', 'true');
    $('.sharepanel').show();
}, function () {
    $('.sharepanel').hide();
    $('.sharepanel').data('show', 'false');
});

/***/ })

},[70]);


// WEBPACK FOOTER //
// js/toproom7e298d.js